import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import { hardwareTypeFromDto } from '@cas/utils/translationHelpers';
import { BarChartByProps } from '../config';
import { ScenarioDataSetLabelV2, ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { GetTooltipTitle } from '../utils';
import { useCallback } from 'react';
import { CustomBarChartLabel, OnCategorySelect } from '../bar-select/BarSelectPlugin';
import { saveFilters, setDeviceTypes } from '@customer/store/slices/filtersSlice';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { isEnumValue } from '@cas/utils/typeHelpers';
import { DeviceType } from '@customer/store/apis/assetsApi';

const getDeviceTypeLabel = (label: ScenarioDataSetLabelV2) => hardwareTypeFromDto(label.name);

const getTooltipTitle: GetTooltipTitle = (_, categoryLabelKey) =>
  hardwareTypeFromDto(categoryLabelKey);

export const BarChartByDeviceType = <T extends ScenarioQueryParams>(props: BarChartByProps) => {
  const dispatch = useAppDispatch();

  const siteId = useAppSelector(state => state.auth.siteId);

  const onCategorySelect = useCallback<OnCategorySelect>(
    ({ name }: CustomBarChartLabel): void => {
      if (siteId && isEnumValue(name, DeviceType)) {
        dispatch(setDeviceTypes([name]));
        dispatch(saveFilters(siteId));
      }
    },
    [dispatch, siteId],
  );

  return (
    <BarChartScenario<T>
      {...props}
      getCategoryLabel={getDeviceTypeLabel}
      getTooltipTitle={getTooltipTitle}
      onCategorySelect={onCategorySelect}
      onBarSelect={onCategorySelect} // Reuse the onCategorySelect callback.
    />
  );
};

export default BarChartByDeviceType;
